import cn from '@/lib/cs';
import React from 'react';

const BinocularsIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8.4 2.4 5.7 4h-1l-.8 2.7L3 9.3 2.2 12l-.8 2.7-.4 1.8.7 2.7 2 2 2.8.8 2.9-.8 2-2 .6-.2.6.1 2 2 2.9.5 2.8-.4 1.8-2.1.9-2.6-.8-2.7-.6-2.5-.9-2.4-1-2.4-.4-2.6-1.2.2L15.6 2l-2.5 2-2.1-.2-2.6-1.4ZM6.5 12.7 9.1 14l1 2.5-1 2.4L6.5 20 4 19l-1-2.5L4 14l2.5-1.3Zm11 0L20 14l1 2.5-1 2.4-2.5 1.1-2.6-1-1-2.5 1-2.5 2.6-1.3Z"
		/>
	</svg>
);

export default BinocularsIcon;
